<template>
  <SoDialog
    v-model="value"
    card-title="Reject winner?"
    :max-width="460"
    data-testid="winner-reject-dialog"
  >
    <p>
      This marks <strong>{{ winner?.surname }}</strong> as
      <strong>rejected</strong> and frees their prize slot, so a selection
      re-run can fill it. <strong>This can't be undone</strong> — a rejected
      winner can't be reinstated.
    </p>
    <div class="d-flex justify-end mt-4">
      <SoButton title="Cancel" class="mr-2" large @click="value = false" />
      <SoButton
        title="Reject winner"
        type="danger"
        large
        :loading="updateMutation.isPending"
        data-testid="winner-reject-confirm-btn"
        @click="confirmReject"
      />
    </div>
  </SoDialog>
</template>

<script lang="ts">
  import { defineComponent, PropType } from "vue"
  import SoDialog from "@/components/SoDialog.vue"
  import SoButton from "@/components/formControls/SoButton.vue"
  import { useSnackbarStore } from "@/stores/snackbar"
  import errorHandler from "@/services/ErrorService/errorHandler"
  import { PrizeDrawEntryWinnerStatus } from "@/api/backofficeRest/generated/model"
  import { IDrawWinner } from "@/models/operations/draw/drawWinner.types"
  import { LoyaltyMutator } from "@/mutators/loyalty/LoyaltyMutator"

  export default defineComponent({
    components: { SoDialog, SoButton },
    props: {
      modelValue: {
        type: Boolean,
        default: false,
      },
      drawId: {
        type: String,
        required: true,
      },
      winner: {
        type: Object as PropType<IDrawWinner | null>,
        default: null,
      },
    },
    emits: ["update:modelValue", "saved"],
    data() {
      return {
        snackbar: useSnackbarStore(),
        updateMutation: LoyaltyMutator.updateWinner(),
      }
    },
    computed: {
      value: {
        get(): boolean {
          return this.modelValue
        },
        set(newValue: boolean) {
          this.$emit("update:modelValue", newValue)
        },
      },
    },
    methods: {
      async confirmReject() {
        if (!this.winner) return
        try {
          await this.updateMutation.mutateAsync({
            drawId: this.drawId,
            winnerId: this.winner.id,
            status: PrizeDrawEntryWinnerStatus.REJECTED,
          })
        } catch (error) {
          errorHandler.showCaughtError(
            error,
            "Failed to reject winner. Please try again.",
          )
          return
        }
        this.snackbar.addSuccess("Winner rejected")
        this.$emit("saved")
        this.value = false
      },
    },
  })
</script>
